export default function AboutHero() {
  return (
    <section className="relative w-full pt-16 md:pt-18">
      <div className="w-full px-4 md:px-10 py-10 md:py-16">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="lg:w-[40%] flex flex-col justify-center">
            <nav className="mb-6" aria-label="面包屑导航">
              <ol className="flex items-center gap-2 text-xs">
                <li>
                  <a href="/" className="text-foreground-400 hover:text-foreground-700 whitespace-nowrap cursor-pointer transition-colors duration-200">
                    首页
                  </a>
                </li>
                <li>
                  <span className="text-foreground-300">/</span>
                </li>
                <li>
                  <span className="text-accent-600 font-medium">关于我们</span>
                </li>
              </ol>
            </nav>

            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-200 text-secondary-800 text-xs font-semibold mb-6 whitespace-nowrap">
              关于黑料吃瓜网
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight mb-6">
              全网最真实的<br />吃瓜第一线
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-md">
              黑料吃瓜网成立于2024年，致力于打造全网最专业、最及时的娱乐八卦资讯聚合平台。我们24小时不打烊，汇聚全网最新鲜的网红八卦、明星黑料和实时热点，为每一位吃瓜群众提供免费、真实、有趣的娱乐资讯服务。
            </p>
          </div>

          <div className="lg:w-[60%]">
            <div className="rounded-2xl overflow-hidden h-56 md:h-80">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20digital%20media%20newsroom%20with%20multiple%20monitors%20showing%20entertainment%20news%2C%20creative%20workspace%2C%20warm%20ambient%20lighting%2C%20editorial%20team%20environment%2C%20trendy%20office%20design%2C%20professional%20atmosphere%2C%20warm%20golden%20and%20cream%20colors&width=1200&height=600&seq=about-hero-banner&orientation=landscape"
                alt="黑料吃瓜网办公环境"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}